import { ContactCard } from "dyl-components";

export const hoverContent = (user, navigate,isInactive) => {
    if (!user) {
        return <div>No User Selected</div>;
    }

    const { id, email, ext, phone } = user;

    return (
        <ContactCard
            userInfo={user}
            toNavigate={() => navigate(`/settings/users/${id}/general`)}
            onEmail={email ? () => { } : null}
            onCall={ext ? () => { } : null}
            onText={phone ? () => { } : null}
            isInactive={isInactive}
            title={" "}
        />
    );
};